export default __webpack_public_path__ + "static/media/wallpaper_bg0.762e0385.jpg";